import { render, staticRenderFns } from "./OrderStats.vue?vue&type=template&id=0673e46a&"
import script from "./OrderStats.vue?vue&type=script&lang=js&"
export * from "./OrderStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports